import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../api/auth.api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import OAuthButtons from "../components/OAuthButtons";
import { markMobileAuthFromSearch } from "../auth/mobileAuth";
import { useTranslation } from "react-i18next";

export default function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [preferredLanguage, setPreferredLanguage] = useState("de");

  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  // App-Login-Flow (?mobile=1) merken, damit OAuth-Registrierung an die App
  // uebergeben werden kann.
  useEffect(() => {
    markMobileAuthFromSearch(window.location.search);
  }, []);

  // Clientseitige Passwort-Validierung
  const isStrongPassword = (password) => {
    return (
      typeof password === "string" &&
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Clientseitige Validierung
    if (!isStrongPassword(password)) {
      setError(t("auth.register.errorWeakPassword"));
      return;
    }

    try {
      await register(firstName, lastName, email, password, preferredLanguage);
      navigate("/register/success", {
        replace: true,
        state: { firstName, lastName },
      });
    } catch (err) {
      if (err?.response?.status === 409) {
        setError(t("auth.register.errorEmailExists"));
      } else if (err?.response?.status === 400) {
        setError(t("auth.register.errorWeakPassword"));
      } else {
        setError(t("auth.register.errorFailed"));
      }
    }
  };

  return (
    <div className="content">
    <Header />
    <form className="login-form" onSubmit={handleSubmit}>
      {/*<img className="login-logo" alt="Data optimizer Logo" src="./data-optimizer-logo.png" />*/}
      <h2 className="login-headline">{t("auth.register.title")}</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <input
        data-testid="register-firstname"
        placeholder={t("auth.register.firstName")}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        required
      />

      <input
        data-testid="register-lastname"
        placeholder={t("auth.register.lastName")}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        required
      />

      <input
        data-testid="register-email"
        placeholder={t("auth.email")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        data-testid="register-password"
        placeholder={t("auth.password")}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <div className="register-language-row">
        <label htmlFor="register-language">
          {t("auth.register.language")}
        </label>
        <select
          id="register-language"
          data-testid="register-language"
          value={preferredLanguage}
          onChange={(e) => setPreferredLanguage(e.target.value)}
        >
          <option value="de">{t("auth.register.languageGerman")}</option>
          <option value="en">{t("auth.register.languageEnglish")}</option>
        </select>
      </div>

      <button className="form-button" data-testid="register-submit" type="submit">{t("auth.register.submit")}</button>

      <OAuthButtons />
    </form>
    <Footer />
    </div>
  );
}